module.exports = __webpack_public_path__ + "img/press-lg@2x.b28fcf3.png";